import PropTypes from 'prop-types'
// material
import { styled } from '@mui/material/styles'
import {
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import SearchIcon from '@mui/icons-material/Search'
import colors from '../../assets/scss/_variables.scss'
// component

// ----------------------------------------------------------------------

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  marginLeft: '-20px',
  // padding: theme.spacing(0, 1, 0, 3),
}))

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': { width: 320 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`,
  },
  '& input::placeholder': {
    color: colors.grey900,
  },
}))

// ----------------------------------------------------------------------

MuiTableToolbar.propTypes = {
  numSelected: PropTypes.number,
  searchTxt: PropTypes.string,
  handleSearch: PropTypes.func,
}

export default function MuiTableToolbar({
  numSelected,
  searchTxt,
  handleSearch,
}) {
  return (
    <RootStyle
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <SearchStyle
          value={searchTxt}
          onChange={handleSearch}
          placeholder="Search..."
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon
                sx={{
                  width: 20,
                  height: 20,
                  color: colors.black,
                }}
              />
            </InputAdornment>
          }
        />
      )}

      {
        numSelected > 0 && (
          <Tooltip title="Delete">
            <IconButton>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )
        //   : (
        //     <Tooltip title="Filter list">
        //       <IconButton>
        //         <DeleteIcon />
        //       </IconButton>
        //     </Tooltip>
        //   )
      }
    </RootStyle>
  )
}
